import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Button } from '../components/ui/button';
import { Copy, Check, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { toast } from 'sonner';

const TEMPLATES = [
  {
    id: 'prospection',
    icon: '1',
    titleKey: 'tpl_prospection',
    subject: 'Équiper votre club avec des tenues 100% personnalisées ?',
    body: `Bonjour [Prénom Nom du responsable],

Je me permets de vous contacter car vous êtes [responsable / entraîneur / président] du club [Nom du club].

Chez Panther, nous concevons des tenues sportives entièrement personnalisées (maillots, survêtements, vestes, polos…) pour les clubs, écoles et associations.

Pourquoi Panther ?

  Design unique créé avec vous
  Tissus techniques (respirants, adaptés à votre sport)
  Impression sublimation HD (couleurs vibrantes et durables)
  Tarifs compétitifs (devis gratuit sous 24h)
  Livraison partout en France

Nous équipons déjà des centaines de clubs comme [Cabestany Handball / FC Thuir / WAB Bejaia / etc.].

Seriez-vous intéressé pour recevoir une maquette gratuite aux couleurs de votre club ?

Je reste à votre disposition pour un échange rapide de 5 minutes cette semaine.

Bien sportivement,

[Prénom Nom]
Commercial – Panther
[Téléphone]
[Email]
www.mypanther.fr`
  },
  {
    id: 'devis',
    icon: '2',
    titleKey: 'tpl_devis',
    subject: 'Votre devis Panther – [Nom du club]',
    body: `Bonjour [Prénom Nom],

Suite à notre échange, je vous transmets votre devis personnalisé pour l'équipement du [Nom du club].

Pièce jointe : Devis Panther – [Nom du club] – [Date]

Récapitulatif :

Produit          Quantité    Prix unitaire    Total
Maillot [design]    XX          XX €          XX €
Short               XX          XX €          XX €
Survêtement         XX          XX €          XX €
TOTAL HT                                     XX €

Ce prix comprend :
  Création graphique offerte
  Sublimation HD
  Livraison incluse
  Personnalisation (logos, noms, numéros)

Validité du devis : 30 jours

Prochaines étapes :
1. Confirmez votre accord sur ce devis
2. Nous réalisons les maquettes 3D (gratuites)
3. Validation finale et lancement production (15 jours)

N'hésitez pas si vous avez des questions ou souhaitez ajuster certains éléments.

Dans l'attente de votre retour,

[Prénom Nom]
[Téléphone]
[Email]`
  },
  {
    id: 'relance-devis',
    icon: '3',
    titleKey: 'tpl_relance_devis',
    subject: 'Suivi de votre devis Panther – [Nom du club]',
    body: `Bonjour [Prénom Nom],

Je reviens vers vous concernant le devis Panther que je vous ai envoyé le [date] pour l'équipement du [Nom du club].

Rappel : [Maillots / survêtements / polos] personnalisés aux couleurs de votre club – [montant] €

Je reste à votre disposition pour :
  Répondre à vos éventuelles questions
  Ajuster les quantités ou produits
  Vous présenter une maquette 3D gratuite

Offre spéciale : Si vous validez votre commande avant le [date], bénéficiez de 10% de produits offerts sur votre commande.

Puis-je vous appeler demain pour en discuter rapidement ?

Dans l'attente de votre retour,

Bien sportivement,

[Prénom Nom]
[Téléphone]`
  },
  {
    id: 'relance-contact',
    icon: '4',
    titleKey: 'tpl_relance_contact',
    subject: 'Une idée pour équiper [Nom du club] ?',
    body: `Bonjour [Prénom Nom],

Je me permets de revenir vers vous car je n'ai pas eu de retour suite à mon précédent message.

Je sais que les clubs reçoivent beaucoup de sollicitations, alors je fais simple :

Panther, c'est quoi ?
  Des maillots 100% personnalisables (couleurs, logos, design unique)
  De la sublimation HD (couleurs qui tiennent)
  Des prix clubs avec devis gratuit sous 24h

Ce que je vous propose :
Une maquette gratuite aux couleurs de [Nom du club] – sans engagement.

Puis-je vous l'envoyer ?

Je reste à votre écoute,

[Prénom Nom]
[Téléphone]`
  },
  {
    id: 'suivi-satisfaction',
    icon: '5',
    titleKey: 'tpl_suivi_satisfaction',
    subject: 'Comment se passent vos nouvelles tenues Panther ?',
    body: `Bonjour [Prénom Nom],

Je prends de vos nouvelles concernant la commande que vous avez reçue le [date] pour le [Nom du club].

Quelques questions rapides :
  Les joueurs sont-ils satisfaits de la qualité des maillots ?
  Les tailles correspondent-elles à vos attentes ?
  Avez-vous besoin d'un complément ou d'un ajustement ?

Nous restons à votre disposition pour toute question ou besoin complémentaire.

Petite demande : Si vous avez des photos de l'équipe en action avec les tenues Panther, nous serions ravis de les partager (avec votre accord) sur nos réseaux.

Parrainez un club : Si vous connaissez un autre club intéressé, parrainez-le et recevez 200€ de bons d'achat !

Merci encore pour votre confiance, et belle saison à toute l'équipe !

[Prénom Nom]
[Téléphone]`
  },
  {
    id: 'fidelisation',
    icon: '6',
    titleKey: 'tpl_fidelisation',
    subject: '[Nom du club] – Préparer la saison prochaine avec Panther',
    body: `Bonjour [Prénom Nom],

Nous espérons que vos nouvelles tenues vous donnent entière satisfaction pour cette saison !

La saison prochaine arrive déjà – c'est le moment de penser aux éventuels besoins complémentaires :
  Nouveaux maillots pour les jeunes recrues ?
  Survêtements ou vestes pour les accompagnateurs ?
  Accessoires (casquettes, gourdes, sacs) pour votre boutique ?

Offre fidélité : Pour toute commande passée avant le [date], bénéficiez de 15% de remise sur votre prochain équipement.

Je reste à votre disposition pour établir un devis ou discuter de vos besoins.

Merci encore pour votre confiance,

[Prénom Nom]
[Téléphone]`
  }
];

const TAG_LABELS = {
  prospection: { color: 'bg-blue-100 text-blue-800 border-blue-200', label: 'PROSPECTION' },
  devis: { color: 'bg-emerald-100 text-emerald-800 border-emerald-200', label: 'DEVIS' },
  'relance-devis': { color: 'bg-amber-100 text-amber-800 border-amber-200', label: 'RELANCE DEVIS' },
  'relance-contact': { color: 'bg-orange-100 text-orange-800 border-orange-200', label: 'RELANCE CONTACT' },
  'suivi-satisfaction': { color: 'bg-purple-100 text-purple-800 border-purple-200', label: 'POST-VENTE' },
  fidelisation: { color: 'bg-pink-100 text-pink-800 border-pink-200', label: 'FIDÉLISATION' },
};

export default function EmailTemplatesPage() {
  const { t } = useLanguage();
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = async (template) => {
    const text = `Objet : ${template.subject}\n\n${template.body}`;
    try {
      await navigator.clipboard.writeText(text);
      setCopiedId(template.id);
      toast.success(t('copied'));
      setTimeout(() => setCopiedId(null), 2000);
    } catch {
      toast.error('Erreur de copie');
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">{t('email_templates_title')}</h1>
          <p className="text-sm text-slate-600 mt-1">{t('email_templates_desc')}</p>
        </div>

        <Card data-testid="email-templates-section" className="border-slate-200 shadow-sm">
          <CardContent className="pt-6">
            <Accordion type="single" collapsible className="w-full">
              {TEMPLATES.map((tpl) => {
                const tag = TAG_LABELS[tpl.id];
                return (
                  <AccordionItem key={tpl.id} value={tpl.id} data-testid={`email-tpl-${tpl.id}`}>
                    <AccordionTrigger className="hover:no-underline py-3">
                      <div className="flex items-center gap-3">
                        <span className={`text-xs font-bold px-2 py-0.5 rounded border ${tag.color}`}>
                          {tpl.icon}
                        </span>
                        <span className={`text-xs font-semibold px-2 py-0.5 rounded border ${tag.color}`}>
                          {tag.label}
                        </span>
                        <span className="text-sm font-medium text-slate-700">{t(tpl.titleKey)}</span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent>
                      <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
                        <div className="flex items-center justify-between mb-3">
                          <p className="text-xs font-semibold text-slate-500 uppercase">{t('email_subject')}</p>
                          <Button
                            size="sm"
                            variant="outline"
                            data-testid={`copy-tpl-${tpl.id}`}
                            className="h-7 text-xs gap-1.5"
                            onClick={() => handleCopy(tpl)}
                          >
                            {copiedId === tpl.id ? (
                              <><Check size={14} className="text-emerald-600" /> {t('copied')}</>
                            ) : (
                              <><Copy size={14} /> {t('copy')}</>
                            )}
                          </Button>
                        </div>
                        <p className="text-sm font-semibold text-slate-800 mb-3 pb-2 border-b border-slate-200">
                          {tpl.subject}
                        </p>
                        <pre className="text-sm text-slate-700 whitespace-pre-wrap font-sans leading-relaxed">
                          {tpl.body}
                        </pre>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
